// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificationV2_notificationTabSection__gT8xD {
  padding: 16px 24px;
}

.notificationV2_searchNotification__1mN8D {
  margin: 16px 0 12px 0;
}

.notificationV2_notificationTimeTitle__Ag8sy {
  font: var(--body-font-three);
  font-weight: 600 !important;
  color: var(--primary-Text);
  text-transform: capitalize;
  margin-bottom: 8px !important;
}

.notificationV2_allNotification__r18vn {
  margin-bottom: 25px;
}

.notificationV2_notificationList__DkR2g {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  background-color: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 12px;
  width: 100%;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_contentRow__la9BU {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationIcon__-cDSr {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--bg3);
  padding: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationIcon__-cDSr img,
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationIcon__-cDSr svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationIcon__-cDSr.notificationV2_paymentSuccess__C-U7d {
  background-color: #EDF7EE;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationIcon__-cDSr.notificationV2_paymentSuccess__C-U7d img,
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationIcon__-cDSr.notificationV2_paymentSuccess__C-U7d svg {
  filter: none;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationContent__wPhxF {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationContent__wPhxF .notificationV2_textRow__TfZ6y {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationContent__wPhxF .notificationV2_notificationTitle__LTG8a {
  flex: 1 1;
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
  white-space: normal;
  line-height: 1.4;
  margin: 0;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationContent__wPhxF .notificationV2_notificationTime__qfOfz {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  white-space: nowrap;
  margin: 0;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationContent__wPhxF .notificationV2_notificationSubheading__HICPM {
  font: var(--body-font-four);
  font-weight: 400;
  white-space: normal;
  color: var(--secondary-Text);
  margin: 0;
  line-height: 1.4;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_dismissButton__I0QMB {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ:hover {
  background-color: var(--bg3);
  border-color: transparent;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ:hover .notificationV2_notificationIcon__-cDSr {
  background-color: var(--white);
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ:hover .notificationV2_dismissButton__I0QMB {
  visibility: visible;
  opacity: 1;
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ.notificationV2_unread__D3uje {
  background-color: var(--bg3);
  border-left: 4px solid var(--brand);
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ.notificationV2_unread__D3uje .notificationV2_notificationIcon__-cDSr {
  background-color: var(--white);
}
.notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ.notificationV2_unread__D3uje .notificationV2_notificationContent__wPhxF .notificationV2_notificationTitle__LTG8a {
  font-weight: 600;
}

@media (max-width: 767px) {
  .notificationV2_notificationTabSection__gT8xD {
    padding: 16px;
  }
  .notificationV2_notificationList__DkR2g {
    gap: 10px;
  }
  .notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ {
    padding: 10px 12px;
  }
  .notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationIcon__-cDSr {
    width: 36px;
    height: 36px;
    padding: 8px;
  }
  .notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationContent__wPhxF .notificationV2_notificationTitle__LTG8a {
    font-size: 13px;
  }
  .notificationV2_notificationList__DkR2g .notificationV2_notificationItem__ABQnQ .notificationV2_notificationContent__wPhxF .notificationV2_notificationSubheading__HICPM {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/notification/notificationV2.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;;AAEA;EACC,qBAAA;AACD;;AAEA;EACC,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;AACD;;AAEA;EACC,mBAAA;AACD;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AACD;AACC;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AACF;AACE;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AACH;AAEE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAAJ;AAGG;EACC,yBAAA;AADJ;AAGI;;EAEC,YAAA;AADL;AAME;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAJH;AAMG;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAJJ;AAOG;EACC,SAAA;EACA,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AALJ;AAQG;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,SAAA;AANJ;AASG;EACC,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;AAPJ;AAWE;EACC,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,cAAA;AATH;AAYE;EACC,4BAAA;EACA,yBAAA;AAVH;AAYG;EACC,8BAAA;AAVJ;AAaG;EACC,mBAAA;EACA,UAAA;AAXJ;AAeE;EACC,4BAAA;EACA,mCAAA;AAbH;AAeG;EACC,8BAAA;AAbJ;AAiBI;EACC,gBAAA;AAfL;;AAsBA;EACC;IACC,aAAA;EAnBA;EAsBD;IACC,SAAA;EApBA;EAsBA;IACC,kBAAA;EApBD;EAsBC;IACC,WAAA;IACA,YAAA;IACA,YAAA;EApBF;EAwBE;IACC,eAAA;EAtBH;EAyBE;IACC,eAAA;EAvBH;AACF","sourcesContent":[".notificationTabSection {\r\n\tpadding: 16px 24px;\r\n}\r\n\r\n.searchNotification {\r\n\tmargin: 16px 0 12px 0;\r\n}\r\n\r\n.notificationTimeTitle {\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 600 !important;\r\n\tcolor: var(--primary-Text);\r\n\ttext-transform: capitalize;\r\n\tmargin-bottom: 8px !important;\r\n}\r\n\r\n.allNotification {\r\n\tmargin-bottom: 25px;\r\n}\r\n\r\n.notificationList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n\r\n\t.notificationItem {\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\t\talign-items: flex-start;\r\n\t\tbackground-color: var(--white);\r\n\t\tborder: 1px solid var(--border);\r\n\t\tborder-radius: var(--border-radius);\r\n\t\tpadding: 12px;\r\n\t\twidth: 100%;\r\n\t\toverflow: hidden;\r\n\t\ttransition: all 0.2s ease-in-out;\r\n\r\n\t\t.contentRow {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: flex-start;\r\n\t\t\tgap: 12px;\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.notificationIcon {\r\n\t\t\twidth: 40px;\r\n\t\t\theight: 40px;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\tbackground-color: var(--bg3);\r\n\t\t\tpadding: 10px;\r\n\t\t\tflex-shrink: 0;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: contain;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\t&.paymentSuccess {\r\n\t\t\t\tbackground-color: #EDF7EE;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\tfilter: none;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.notificationContent {\r\n\t\t\tflex: 1;\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 4px;\r\n\t\t\tcursor: pointer;\r\n\r\n\t\t\t.textRow {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\talign-items: flex-start;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t}\r\n\r\n\t\t\t.notificationTitle {\r\n\t\t\t\tflex: 1;\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\twhite-space: normal;\r\n\t\t\t\tline-height: 1.4;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t}\r\n\r\n\t\t\t.notificationTime {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t}\r\n\r\n\t\t\t.notificationSubheading {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\twhite-space: normal;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\tline-height: 1.4;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.dismissButton {\r\n\t\t\tvisibility: hidden;\r\n\t\t\topacity: 0;\r\n\t\t\ttransition: opacity 0.2s ease;\r\n\t\t\tflex-shrink: 0;\r\n\t\t}\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: var(--bg3);\r\n\t\t\tborder-color: transparent;\r\n\r\n\t\t\t.notificationIcon {\r\n\t\t\t\tbackground-color: var(--white);\r\n\t\t\t}\r\n\r\n\t\t\t.dismissButton {\r\n\t\t\t\tvisibility: visible;\r\n\t\t\t\topacity: 1;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.unread {\r\n\t\t\tbackground-color: var(--bg3);\r\n\t\t\tborder-left: 4px solid var(--brand);\r\n\r\n\t\t\t.notificationIcon {\r\n\t\t\t\tbackground-color: var(--white);\r\n\t\t\t}\r\n\r\n\t\t\t.notificationContent {\r\n\t\t\t\t.notificationTitle {\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.notificationTabSection {\r\n\t\tpadding: 16px;\r\n\t}\r\n\r\n\t.notificationList {\r\n\t\tgap: 10px;\r\n\r\n\t\t.notificationItem {\r\n\t\t\tpadding: 10px 12px;\r\n\r\n\t\t\t.notificationIcon {\r\n\t\t\t\twidth: 36px;\r\n\t\t\t\theight: 36px;\r\n\t\t\t\tpadding: 8px;\r\n\t\t\t}\r\n\r\n\t\t\t.notificationContent {\r\n\t\t\t\t.notificationTitle {\r\n\t\t\t\t\tfont-size: 13px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.notificationSubheading {\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationTabSection": `notificationV2_notificationTabSection__gT8xD`,
	"searchNotification": `notificationV2_searchNotification__1mN8D`,
	"notificationTimeTitle": `notificationV2_notificationTimeTitle__Ag8sy`,
	"allNotification": `notificationV2_allNotification__r18vn`,
	"notificationList": `notificationV2_notificationList__DkR2g`,
	"notificationItem": `notificationV2_notificationItem__ABQnQ`,
	"contentRow": `notificationV2_contentRow__la9BU`,
	"notificationIcon": `notificationV2_notificationIcon__-cDSr`,
	"paymentSuccess": `notificationV2_paymentSuccess__C-U7d`,
	"notificationContent": `notificationV2_notificationContent__wPhxF`,
	"textRow": `notificationV2_textRow__TfZ6y`,
	"notificationTitle": `notificationV2_notificationTitle__LTG8a`,
	"notificationTime": `notificationV2_notificationTime__qfOfz`,
	"notificationSubheading": `notificationV2_notificationSubheading__HICPM`,
	"dismissButton": `notificationV2_dismissButton__I0QMB`,
	"unread": `notificationV2_unread__D3uje`
};
export default ___CSS_LOADER_EXPORT___;
